export default __webpack_public_path__ + "media/images/user_photos/109-a4a50bd968139a8086b539faa2b08841.jpg";